import { memo } from "react";

export const ExtendedWarrantyPurchasedDetails = memo(
  function ExtendedWarrantyPurchasedDetails() {
    return null;
  },
);
